namespace Ir.Components.Workbook.Settings.Items.UnitFormatSetting {
    export interface IUnitFormatSettingParams {
        value: KnockoutObservable<LabelFormatEnum>;
        disabled?: KnockoutObservable<boolean> | boolean;
    }
    interface IViewModel {
        options: DevExpress.ui.dxSelectBox.Properties;
        label: string;
        disabled?: KnockoutObservable<boolean> | boolean;
    }

    interface IParams {
        config: IUnitFormatSettingParams;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        this.label = "Unit";
        this.disabled = params.config.disabled === undefined ? false : params.config.disabled as any;
        this.options = {
            displayExpr: 'text',
            valueExpr: 'value',
            value: params.config.value,
            items: [
                { value: LabelFormatEnum.Automatic, text: 'Automatic' },
                { value: LabelFormatEnum.Normal, text: 'Normal' },
                { value: LabelFormatEnum.Thousands, text: 'Thousands' },
                { value: LabelFormatEnum.Millions, text: 'Millions' },
                { value: LabelFormatEnum.Billions, text: 'Billions' }
            ],
            width: 117,
            disabled: this.disabled as any,
        };
    }
}